import React from 'react';
import PropTypes from 'prop-types';

const Emoji = (props) => {
  let emojiToDisplay = null;

  emojiToDisplay = props.emoji;

  return (
    <div>
      {emojiToDisplay}
    </div>
  );
};
Emoji.propTypes = {
  emoji: PropTypes.string.isRequired,
};

export default React.memo(Emoji);
